import { Component, OnInit, Input } from '@angular/core';
import { PCCService } from 'src/app/services/pcc.service';
import { ToastrService } from 'ngx-toastr';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { MatTableDataSource } from '@angular/material/table';
import { IActivitiesOfDailyLivingResponse } from 'src/app/services/pccAPIInterfaces';

@Component({
  selector: 'app-activities-of-daily-living',
  templateUrl: './activities-of-daily-living.component.html',
  styleUrls: ['./activities-of-daily-living.component.css']
})
export class ActivitiesOfDailyLivingComponent implements OnInit {

  @Input('patient') patient;
  // @Input('pccOrgUuid') pccOrgUuid;
  constructor(private _pccService: PCCService,
    private toastr:ToastrService,
    private loader: NgxUiLoaderService) { }
  pccOrgUuid:string;
  apiData: IActivitiesOfDailyLivingResponse;
  page = 1;
  dataSource;
  displayedColumns = [
    "mdsQuestionKey",
    "questionDescription",
    "response"
  ];

  loaderId ='medications-loader';
  inprogress = false;

  view:''|'administration'|'schedules'|'activities-of-daily-living-response' = '';
  viewData;

  ngOnInit(): void {
    this.pccOrgUuid = this.patient.facility_id_ref.pcc_orgUuid;
    this.loadData(this.page);
  }

  loadData(page) {
    this.loader.startLoader(this.loaderId);
    let authMode;
    if(!this.patient.facility_id_ref.pcc_2_legged_authentication) {
      authMode = 'APP'
    }
    this._pccService.getActivitiesOfDailyLiving({
        pccOrgUuid: this.pccOrgUuid,
        pccPatientId: this.patient.pcc_patientId,
        pccPage: String(page),
        authMode
      }).subscribe((response: any) => {

      if (response.status === 200) {
        this.apiData = response.data;
        this.dataSource = new MatTableDataSource(this.apiData.data);
        this.page = page;
      } else {
        this.toastr.error('Something went wrong while fetching ActivitiesOfDailyLiving data');
      }
    }, (error) => {
      this.toastr.error('Something went wrong while fetching ActivitiesOfDailyLiving data');
    }, () => {
      this.loader.stopLoader(this.loaderId);
    })
  }
  navigate(prevNext) {
    const newPageNo = this.page + prevNext;
    this.loadData(newPageNo);
  }

  changeView(view, viewData) {
    this.view = view;
    this.viewData = viewData;

  }


}
